module.exports = __webpack_public_path__ + "static/media/icon_131.9aab216a.png";